import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';
import { WeightMap } from 'common/post/PostVotes/Constants';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsSectionLink from '../APIDocsSectionLink';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsCreateVoteBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Create vote</div>
          <div className="text">Creates a new vote.</div>
          <div className="text">
            You may also want to use the{' '}
            <APIDocsSectionLink
              sectionID="create_or_update_user"
              onScrollToSection={this.props.onScrollToSection}
            />{' '}
            endpoint to make sure the voter's account exists (and fetch their id).
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description:
                  'The unique identifier of the user who cast the vote on behalf of the voter. Must be a Canny administrator.',
                heading: 'byID',
                subheading: 'string (optional)',
              },
              {
                description:
                  'If the vote is being moved from another source, the date this vote was originally created in ISO 8601 format.',
                heading: 'createdAt',
                subheading: 'string (optional)',
              },
              {
                description: 'The unique identifier of the post to vote on.',
                heading: 'postID',
                subheading: 'string',
              },
              {
                description: 'The unique identifier of the voter.',
                heading: 'voterID',
                subheading: 'string',
              },
              {
                description: `The priority of the vote. Can be one of ${Object.entries(WeightMap)
                  .map(([index, weight]) => `${index} (${weight.name})`)
                  .join(', ')}.`,
                heading: 'votePriority',
                subheading: 'number (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            Returns "success" if the vote was successfully created or already exists.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/votes/create</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/votes/create"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d postID=553c3ef8b8cdcd1501ba1240 \\
    -d voterID=553c3ef8b8cdcd1501ba1238`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">success</Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
